import * as Yup from 'yup';

export const createFolderValidationSchema = Yup.object().shape({
  name: Yup.string().required().max(100).label('Name'),
});
